import { useDemandOptions } from '#features/useDemandOptions';
import {
  demandSourceMatchTemplateCreate,
  DemandSourceMatchTemplateFieldEntity,
} from '#services/api';
import { Form, Message, Modal } from '@bedrock/components';
import SFormItem from '@mpc/common/src/components/SForm/SFormItem';
import { useMemoizedFn } from 'ahooks';
import React, {
  forwardRef,
  useImperativeHandle,
  useRef,
  useState,
} from 'react';
import styles from './index.less';
import classnames from 'classnames/bind';

const cx = classnames.bind(styles);

export interface SaveAsNewTemplateRefType {
  open: (entitiesData: DemandSourceMatchTemplateFieldEntity[]) => void;
  close: () => void;
}

const SaveAsNewTemplate = forwardRef<
  SaveAsNewTemplateRefType,
  { onClose?: () => void; onOk?: () => void }
>(({ onClose, onOk }, ref) => {
  const [visible, setVisible] = useState(false);
  const [form] = Form.useForm();
  const entitiesDataRef = useRef<DemandSourceMatchTemplateFieldEntity[]>([]);
  const [loading, setLoading] = useState(false);

  const { optionsMap } = useDemandOptions({
    keys: ['main_platform', 'product'],
  });

  useImperativeHandle(ref, () => ({
    open,
    close,
  }));

  const open = useMemoizedFn(
    (entitiesData: DemandSourceMatchTemplateFieldEntity[]) => {
      entitiesDataRef.current = entitiesData;
      setVisible(true);
    }
  );

  const handleOnOk = useMemoizedFn(() => {
    setLoading(true);
    form
      .validateFields()
      .then((values: any) => {
        console.log(values);
        return demandSourceMatchTemplateCreate({
          ...values,
          demand_source_match_template_field_entities:
            entitiesDataRef.current.map((item) => ({
              field_name: item.field_name,
              plan_remark: item.plan_remark,
              value_example: item.value_example,
            })),
        }).then((res: any) => {
          if (res.code === 1) {
            Message.success('保存成功');
            setVisible(false);
            onOk?.();
          }
        });
      })
      .finally(() => {
        setLoading(false);
      });
  });

  const handleOnCancel = useMemoizedFn(() => {
    setVisible(false);
    onClose?.();
  });

  return (
    <Modal
      visible={visible}
      onCancel={handleOnCancel}
      onClose={handleOnCancel}
      title="存为新模版"
      width={480}
      okText="确定"
      cancelText="取消"
      onOk={handleOnOk}
      okButtonProps={{ loading }}
      cancelButtonProps={{ loading }}
    >
      <Form
        form={form}
        layout="vertical"
        showLabelColon
        preserve={false}
        className={cx('save-as-new-template-form')}
        initialValues={{state: true}}
      >
        <SFormItem
          formItemKey={'product_id'}
          label="产品"
          required
          componentClass="select"
          elementProps={{
            multiple: true,
            options: optionsMap.product?.options || [],
            type: 'label',
            returnOnlyLeaf: true,
            maxTagCount: 'responsive',
            showReset: true,
            showConfirm: true,
          }}
        />
        <SFormItem
          formItemKey={'main_platform'}
          label="平台"
          required
          componentClass="select"
          elementProps={{
            multiple: true,
            options: optionsMap.main_platform?.options || [],
            type: 'label',
            maxTagCount: 'responsive',
            showReset: true,
            showConfirm: true,
          }}
        />
        <SFormItem
          formItemKey="name"
          label="模版名称"
          required
          componentClass="input"
          elementProps={{
            placeholder: '请输入',
            maxLength: 20,
            showCount: true,
            style: {
              width: '100%',
            },
          }}
        />
        <SFormItem
          formItemKey="state"
          label="状态"
          required
          componentClass="radio"
          elementProps={{
            options: [
              { name: '启用', value: true },
              { name: '禁用', value: false },
            ],
          }}
        />
      </Form>
    </Modal>
  );
});

export default SaveAsNewTemplate;
